import { render, staticRenderFns } from "./Commands.vue?vue&type=template&id=cf4c210a"
import script from "./Commands.vue?vue&type=script&lang=ts"
export * from "./Commands.vue?vue&type=script&lang=ts"
import style0 from "./Commands.vue?vue&type=style&index=0&id=cf4c210a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports